import { useEffect, useRef, useState } from 'react';

const GOOGLE_MAPS_SCRIPT_ID = 'google-maps-script';

function loadGoogleMapsScript(apiKey) {
     return new Promise((resolve) => {
          if (document.getElementById(GOOGLE_MAPS_SCRIPT_ID)) {
               resolve();
               return;
          }
          const script = document.createElement('script');
          script.id = GOOGLE_MAPS_SCRIPT_ID;
          script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
          script.async = true;
          script.onload = resolve;
          document.head.appendChild(script);
     });
}

export default function useGooglePlaces(inputRef, onPlaceSelected) {
     const autocompleteRef = useRef(null);
     const [loaded, setLoaded] = useState(false);
     const apiKey = process.env.REACT_APP_GOOGLE_PLACES_API_KEY;

     useEffect(() => {
          if (!apiKey) return;
          loadGoogleMapsScript(apiKey).then(() => setLoaded(true));
     }, [apiKey]);

     useEffect(() => {
          if (!loaded || !inputRef.current || autocompleteRef.current) return;

          const autocomplete = new window.google.maps.places.Autocomplete(
               inputRef.current,
               {
                    types: ['address'],
                    componentRestrictions: { country: 'us' },
               }
          );

          autocomplete.addListener('place_changed', () => {
               const place = autocomplete.getPlace();
               if (!place.address_components) return;

               let street = '';
               let city = '';
               let state = '';
               let zip = '';

               for (const component of place.address_components) {
                    const type = component.types[0];
                    if (type === 'street_number') {
                         street = component.long_name + ' ';
                    } else if (type === 'route') {
                         street += component.long_name;
                    } else if (type === 'locality') {
                         city = component.long_name;
                    } else if (type === 'administrative_area_level_1') {
                         state = component.short_name;
                    } else if (type === 'postal_code') {
                         zip = component.long_name;
                    }
               }

               onPlaceSelected({
                    address: street.trim(),
                    city,
                    state,
                    zip,
               });
          });

          autocompleteRef.current = autocomplete;
     }, [loaded, inputRef, onPlaceSelected]);
}
